import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as C}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const i=C`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22 6.94922V18.9492C22 19.4992 21.8042 19.9701 21.4125 20.3617C21.0208 20.7534 20.55 20.9492 20 20.9492H4C3.45 20.9492 2.97917 20.7534 2.5875 20.3617C2.19583 19.9701 2 19.4992 2 18.9492V6.94922C2 6.39922 2.19583 5.92839 2.5875 5.53672C2.97917 5.14505 3.45 4.94922 4 4.94922H20C20.55 4.94922 21.0208 5.14505 21.4125 5.53672C21.8042 5.92839 22 6.39922 22 6.94922ZM4 8.94922H20V6.94922H4V8.94922ZM4 12.9492V18.9492H20V12.9492H4Z"
            fill="#FCFCFC" />
    </svg>
`,l=t("credit_card",i),s=t("debit_credit",i),n=t("credit_card_filled",C`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 20.9492C3.45 20.9492 2.97917 20.7534 2.5875 20.3617C2.19583 19.9701 2 19.4992 2 18.9492V6.94922C2 6.39922 2.19583 5.92839 2.5875 5.53672C2.97917 5.14505 3.45 4.94922 4 4.94922H20C20.55 4.94922 21.0208 5.14505 21.4125 5.53672C21.8042 5.92839 22 6.39922 22 6.94922V18.9492C22 19.4992 21.8042 19.9701 21.4125 20.3617C21.0208 20.7534 20.55 20.9492 20 20.9492H4ZM4 12.9492H20V8.94922H4V12.9492Z"
                fill="#FCFCFC" />
        </svg>
    `);export{l as CreditCard,n as CreditCardFilled,s as DebitCredit};
